import type { FC, PropsWithChildren } from 'react';
import { useRouterState } from '@tanstack/react-router';

import { IncompleteContent } from './components/incomplete-content';
import { PendingContent } from './components/pending-content';
import { NoAccessAccountGroup } from './components/no-access-group-content';

interface ContentProps extends PropsWithChildren {
  statusRegistered: string;
  isAccountGroup?: boolean;
}

const restrictedPaths = ['/account-group', '/group-commission'];

const Content: FC<ContentProps> = ({ children, statusRegistered, isAccountGroup }) => {
  const { location } = useRouterState();
  const shouldCheckAccess = restrictedPaths.some((path) => location.pathname.startsWith(path));

  switch (statusRegistered) {
    case 'INCOMPLETE':
      return <IncompleteContent />;
    case 'PENDING':
      return <PendingContent />;
  }

  if (shouldCheckAccess && isAccountGroup === false) {
    return <NoAccessAccountGroup />;
  }

  return <main className="content">{children}</main>;
};

export default Content;
